<template>
    <div class="content">
        <!-- 查询和其他操作 -->
          <Form ref="formValidate" :model="listQuery" :label-width="80">
            <Row>
                <Col span="4">
                    <FormItem label="状态" class="mb-10" style="95%">
                        <Select v-model="listQuery.status"    placeholder="请选择状态">
                            <Option  value="1" >启用</Option>
                            <Option  value="2" >停用</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem :label-width="0" class="mb-10" style="margin-left:10px">
                        <Button   type="primary" icon="ios-search" @click="searchList">查询</Button>
                        <Button  type="primary" icon="ios-search" @click="emptyFilter">清空筛选</Button>
                        <Button  width="100%" icon="ios-add" type="primary" @click="addChannelTag('isAdd')">添加</Button>
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <!-- <div class="search_bar">   
            <div class="search_bar_item">
                <span>状态：</span>
                <Select v-model="listQuery.status"   style="width:200px" placeholder="请选择部门">
                    <Option  value="1" >启用</Option>
                    <Option  value="2" >停用</Option>
                </Select>
            </div>
            <div class="search_bar_item">
                <Button   type="primary" icon="ios-search" @click="getList">查询</Button>
            </div>
            <div class="search_bar_item">
                <Button  type="primary" icon="ios-search" @click="emptyFilter">清空筛选</Button>
            </div>
            
            <div class="search_bar_item">
                <Button  width="100%" icon="ios-add" type="primary" @click="addChannelTag('isAdd')">添加</Button>
            </div>
        </div> -->

        <div class="table_wrap">
            <div style="width:100%">
                <Table   stripe border ref="table"
                    :height="tableHeight"
                    :loading="tabLoading"
                    :columns="tabColumns" 
                    :data="tabData"
                ></Table>
                <div style="margin-top:20px;display:flex;justify-content:flex-end">
                    <Page show-total show-elevator show-sizer  :page-size-opts="pageSizeOpts" :page-size="50"
                        :total="total"  :current="listQuery.page"
                        :transfer="true"
                        @on-change="changePage" 
                        @on-page-size-change="changeLimit"/>
                </div>
            </div>
        </div>

         <!-- 添加|编辑渠道标签对话框 -->
        <Modal
            v-model="showAddChannelTag"
            :closable="false"
            :mask-closable="false"
            class-name="vertical-center-modal">
                <p slot="header" class="modal_title">
                    <span>{{isTitle}}</span>
                </p>
                <p v-if="isTitle=='修改渠道标签'" class="modal_text">停用标签，相关渠道将删除该标签，请慎重操作</p>
                <Form  ref="addChannelTagForm" :model="addChannelTagForm" :rules="addChannelTagFormRule" :label-width="80" >
                    <FormItem label="名称" prop="name">
                        <Input v-model="addChannelTagForm.name" style="width:90%"   placeholder="请输入渠道标签名称" @keydown.native.enter.prevent ="handleEnter"></Input>
                    </FormItem>
                    <FormItem label="状态" prop="status">
                        <RadioGroup v-model="addChannelTagForm.status"  style="width:90%" >
                            <Radio  label='1'>启用</Radio>
                            <Radio  label='2'>停用</Radio>
                        </RadioGroup>
                    </FormItem>
                </Form>

                <div slot="footer">
                    <Button type="primary" size="large"  @click="handleSubmit('addChannelTagForm',isTitle)">确定</Button>
                    <Button  size="large"  @click="handleReset('addChannelTagForm')">取消</Button>
                </div>
        </Modal>
    </div>
</template>
<script>
export default {
    name:'channelTagManagement',
    data(){
        return{
            storeList:[],
            departmentList:[],
            channelTagList:[],
            showAddChannelTag:false,
            tableHeight:650,
            tabLoading:false,
            tabData:[],
            tabColumns: [
                    {
                        title: '序号',
                        type: 'index',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: 'ID',
                        key: 'id',
                        align:'center',
                        width:100,
                    },
                    {
                        title: '渠道标签',
                        key: 'name',
                        align:'center',
                       
                    },
                    {
                        title: '状态',
                        key: 'status_text',
                        align:'center',
                      
                    },
                    {
                        title: '操作',
                        width: 200,
                        align: 'center',
                        render: (h, params) => {
                            // console.log('操作params',params)
                            switch(params.row.status){
                                case 1:
                                    return h('div', [
                                        h('Button', {
                                            props: {
                                                type: 'primary',
                                                size: 'small'
                                            },
                                            style: {
                                                marginRight: '5px'
                                            },
                                            on: {
                                                click: () => {
                                                    this.addChannelTag(params.row.id)
                                                }
                                            }
                                        }, '修改')
                                    ]);
                                break;
                                case 2:
                                    return h('div', [
                                        h('Button', {
                                            props: {
                                                type: 'primary',
                                                size: 'small'
                                            },
                                            style: {
                                                marginRight: '5px'
                                            },
                                            on: {
                                                click: () => {
                                                    this.addChannelTag(params.row.id)
                                                }
                                            }
                                        }, '修改'),
                                        h('Button', {
                                            props: {
                                                type: 'error',
                                                size: 'small'
                                            },
                                            style: {
                                                marginRight: '5px'
                                            },
                                            on: {
                                                click: () => {
                                                    this.$Modal.confirm({
                                                        title: '删除提示',
                                                        content: '<p>确认要删除此标签吗？</p>',
                                                        onOk: () => {
                                                            this.apiDeleteChannelTga(params.row)
                                                        },
                                                        onCancel: () => {
                                                            
                                                        }
                                                    });
                                                   
                                                }
                                            }
                                        }, '删除')
                                    ]);
                                break;
                            }
                        }
                    }
                ],
           
            // 列表查询参数
            listQuery:{
                page:1,
                limit:50,
                status:''
            },
            total:0,
            pageSizeOpts:[50,60,70,80,90,100],
            styles: {
                height: 'calc(100% - 55px)',
                overflow: 'auto',
                paddingBottom: '53px',
                position: 'static'
            },
            stylesModal:{
                height: '500px',
                overflow: 'auto',
                // position: 'static'
            },

            isTitle:'添加渠道标签',
            isEditorChannelId:'',
            addChannelTagForm:{
                name:'',
                status:'',
            },
          

            addChannelTagFormRule:{
                name: [
                    { required: true, message: '请输入渠道名称', trigger: 'blur' }
                ],
                status: [
                    { required: true, message: '请选择状态', trigger: 'change' }
                ]
            }
        }
    },
    created(){
        this.getList()
    },
    mounted() {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 220
    },
    methods:{
        handleEnter(){
            return false;
        },
        // 渠道详情
        apiChannelTagDetails(id){
            serve.fetchGet(api.crmChannelTag+'/'+id,{}).then(res => {
                this.addChannelTagForm.name=res.data.name
                this.addChannelTagForm.status=res.data.status.toString()
                this.showAddChannelTag=true
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },

        // 删除渠道
        apiDeleteChannelTga(param){
            serve.fetchDelete(api.crmChannelTag+"/"+param.id,{}).then(res => {
                this.$Message.success('删除成功');
                this.getList()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },

        // 修改渠道标签
        apiEditorChannelTag(){
            serve.fetchPut(api.crmChannelTag+"/"+this.isEditorChannelId,this.addChannelTagForm).then(res => {
                this.showAddChannelTag=false
                this.getList()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },

        //  添加渠道标签
        apiAddChannelTag(){
            serve.fetchPost(api.crmChannelTag,this.addChannelTagForm).then(res => {
                this.showAddChannelTag=false
                this.$Message.success('添加成功');
                this.getList()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        // 获取列表
        getList(){
            this.tabLoading=true
            serve.fetchGet(api.crmChannelTag,this.listQuery).then(res => {
                var data=res.data;
                console.log('渠道标签列表',data)
               
                this.tabData=data
                this.total=res.meta.pagination.total
                this.tabLoading=false
            }).catch((err=>{
                this.tabLoading=false
                this.$Message.error(error.response.data.message);
            })) 
        },
        changePage(val){
            this.listQuery.page=val
            this.getList()
        },
        changeLimit(val){
            this.listQuery.limit=val
            this.getList()
        },
        changeDepartment(val){
            this.apiOpenStore(val)
        },
        // 清空筛选
        emptyFilter(){
            this.listQuery.page=1
            this.listQuery.status=''
            this.getList()
        },
         // 查询
        searchList(){
            this.listQuery.page=1
            this.getList()
        },
        // 添加，编辑渠道
        addChannelTag(id){
            console.log(id)
            if(id!=='isAdd'){
                this.isTitle='修改渠道标签'
                this.isEditorChannelId=id
                this.apiChannelTagDetails(id)
            }else{
                this.isTitle='添加渠道标签'
                this.isEditorChannelId=''
                this.addChannelTagForm.name=''
                this.addChannelTagForm.status=''
                this.showAddChannelTag=true
            }
        },   
        // 确认
        handleSubmit (name,isTitle) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    switch(name){
                        case 'addChannelTagForm':
                            if(isTitle=='添加渠道标签'){
                                this.apiAddChannelTag()
                            }else if(isTitle=='修改渠道标签'){
                                this.apiEditorChannelTag()
                            }
                        break;
                    }
                } else {
                    this.$Message.error('请完善表单');
                }
            })
        },
        // 取消
        handleReset (name) {
            this.$refs[name].resetFields();
            switch(name){
                case 'addChannelTagForm':
                    this.showAddChannelTag=false
                break;
            }
        }
    }
}
</script>
<style>
.mr-t-10{
    margin-top: 10px;
}
.content{

}
.search_bar{
    display: flex;
    justify-content: flex-start;
    flex-direction:row;
    flex-wrap: wrap;
}
.search_bar_item{
    /* text-align: center; */
    margin: 4px;
  }
.other_search_bar{
    display: flex;
    justify-content: flex-start;
    flex-direction:row;
    flex-wrap: wrap;
}
 
.table_wrap{
    margin: 12px 12px 12px 0px;
}
.ivu-btn-icon-only {
    margin-left: 4px; 
    padding: 0px !important;
    font-size: 18px!important;
}
.ivu-table-cell {
    white-space: pre-line!important;
}
.ivu-drawer-header-inner {
    font-size: 20px!important;
}
.table_tip{
    margin: 0 0 10px 0px;
}
.demo-drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
    z-index: 10;
}
.user_info_wrap{
    display: flex;
    justify-content:space-between;
    flex-direction:row;
    flex-wrap: wrap;
    height:40px;
    color: #464c5b;
    font-weight: 600;
    font-size: 14px;
    line-height: 40px;
    background: #f8f8f9;
    margin:10px 0 ;
}
.vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
}
.vertical-center-modal  .ivu-modal{
    top: 0;
}
.modal_title{
    text-align: center;
}
.modal_text{
    color:red;
    text-align:center;
    margin-bottom:16px
}
.user_info_text_wrap{
    height: 46px;
    padding-top: 10px;
    padding-left: 32px;
    /* line-height: 56px; */

    /* padding: 10px; */
}
.opertionBtn{
    margin-bottom:20px;
    display:flex;
    display: -webkit-flex;
    align-items: center
}
.opertionBtn .item{
    margin-right: 5px
}
.mb-10{
    margin-bottom: 10px
}
</style>


// WEBPACK FOOTER //
// src/pages/Crm/CrmSetting/channelTagManagement.vue